import { en } from './en';
import { ru } from './ru';

export const locales = {
  en: {
    ...en,
  },
  ru: {
    ...ru,
  },
};
